import React, { useState, useEffect } from "react";
import './break.css';
import placesData from '../../assets/placesData.json'; // Path to your JSON file

function Break() {
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredPlaces, setFilteredPlaces] = useState(placesData);
    const [selectedPlace, setSelectedPlace] = useState(placesData[0]); // Default place selected

    useEffect(() => {
        const results = placesData.filter(place =>
            place.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredPlaces(results);
        if (results.length > 0) {
            setSelectedPlace(results[0]);
        } else {
            setSelectedPlace(null);
        }
    }, [searchTerm]);

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    return (
        <div className="break">
            <div className="component-name">How It Works?</div>
            <div className="component-head">
                <h2>Discover the Journey</h2>
                <p>Embark on an unforgettable adventure with our expertly curated travel experiences.</p>
            </div>
            <div className="break-section">
                <div className="break-content">
                    <div className="break-1">
                        {selectedPlace ? (
                            <div id="break-footer1">
                                <h2>
                                    <span role="img" aria-label="star">⭐</span>
                                    {selectedPlace.rating}/5
                                </h2>
                                <p>{selectedPlace.name}</p>
                                <div id="bar">
                                    <div style={{ width: `${selectedPlace.rating * 20}%` }}></div>
                                </div>
                            </div>
                        ) : (
                            <div id="break-footer1">
                                <h2>Search for a place</h2>
                            </div>
                        )}
                        <div id="break-footer2">
                            <h2>Places in {selectedPlace ? selectedPlace.name : "your search"}</h2>
                            <div id="places">
                                {selectedPlace && selectedPlace.places.map((name, index) => (
                                    <p key={index}>{name}</p>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="break-2">
                        <div className="tab">
                            <div id="tab1">
                                <h2>Take a Break!</h2>
                                <p>Indulge in the freedom of exploration with effortless planning.</p>
                            </div>
                            <button>Explore New Places &nbsp; &gt;</button>
                        </div>
                        <div className="where">
                            <h3>Search for places &nbsp;
                                <i class="fas fa-search flip-icon"></i>
                            </h3>
                            <input
                                type="text"
                                placeholder="Search places..."
                                value={searchTerm}
                                onChange={handleSearch}
                                style={{ padding: '10px', width: '90%' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Break;
